/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestRunSummaryViewModel } from '../../models/test-run-summary-view-model';

export interface ApiAdminApiTestsGet$Params {
}

export function apiAdminApiTestsGet(http: HttpClient, rootUrl: string, params?: ApiAdminApiTestsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TestRunSummaryViewModel>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<TestRunSummaryViewModel>>;
    })
  );
}

apiAdminApiTestsGet.PATH = '/api/Admin/ApiTests';
